exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".max_text_w[data-v-5a1fb9bc]{width:100px;display:inline-block}", ""]);

// exports
